// src/pages/Vouchers/TaxPaymentForm.jsx
import React from 'react';
import VoucherForm, { VOUCHER_CONFIGS } from './VoucherForm';

export default function TaxPaymentForm() {
  return <VoucherForm config={VOUCHER_CONFIGS.taxPayment} />;
}
